import useProjectId from '../../hooks/useProjectId';

const useProjectRoot = () => {
  const projectId = useProjectId();

  return `/projects/${projectId}`;
};

export default useProjectRoot;
